module.exports = {
  label: {
    enterOtp: 'Enter OTP',
    resendOtp: 'Resend OTP',
    buttons: {
      back: 'Back',
      home: 'Home'
    }
  }
};